var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.291)",
    fill: "#ed8b00",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_634",
    "data-name": "Mask Group 634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share-alt",
    d: "M13.75,12.5a3.729,3.729,0,0,0-2.582,1.031l-3.84-2.4a3.773,3.773,0,0,0,0-2.258l3.84-2.4A3.749,3.749,0,1,0,10,3.75a3.8,3.8,0,0,0,.172,1.129l-3.84,2.4a3.75,3.75,0,1,0,0,5.438l3.84,2.4A3.823,3.823,0,0,0,10,16.25a3.75,3.75,0,1,0,3.75-3.75Zm0-10.625A1.875,1.875,0,1,1,11.875,3.75,1.875,1.875,0,0,1,13.75,1.875Zm-10,10A1.875,1.875,0,1,1,5.625,10,1.875,1.875,0,0,1,3.75,11.875Zm10,6.25a1.875,1.875,0,1,1,1.875-1.875A1.875,1.875,0,0,1,13.75,18.125Z",
    transform: "translate(5.541 4.291)",
    fill: "#ed8b00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeShare);
export default __webpack_public_path__ + "static/media/orange-share.684220bbc55e4a53e66ab590d4ebba9d.svg";
export { ForwardRef as ReactComponent };